import type * as Types from '../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CatalogPdpDisplayFieldsFragment = {
  __typename?: 'ProductCatalogItem';
  whyWeLoveIt?: string | null;
  shortDescription?: string | null;
  longDescription?: string | null;
  id: string;
  title: string;
  itemType: string;
  productUrl?: string | null;
  isFullPrice: boolean;
  tags: Array<string>;
  retailer?: { __typename?: 'ProductCatalogRetailer'; name: string } | null;
  subCategories: Array<{ __typename?: 'ProductCatalogCategory'; id: string; publicUrlPath: string; title: string }>;
  brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
  photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
  price?: {
    __typename?: 'MonetaryValue';
    valueInMinorUnits: number;
    floatingPointDecimalString: string;
    currency?: { __typename?: 'Currency'; code: string; places: number } | null;
  } | null;
  fullPrice?: {
    __typename?: 'MonetaryValue';
    valueInMinorUnits: number;
    floatingPointDecimalString: string;
    currency?: { __typename?: 'Currency'; code: string; places: number } | null;
  } | null;
  storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo'; storefrontStatus: Types.ProductCatalogStorefrontStatus; canAddToCart: boolean; canAddToRegistry: boolean };
  rating?: { __typename?: 'RatingProduct'; id: string; stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number } } | null;
};

export type CatalogPdpDimensionsFragment = {
  __typename?: 'ProductCatalogItem';
  groupDimensionOptions: Array<{
    __typename?: 'ProductCatalogItemGroupDimensionOption';
    id: string;
    displayString: string;
    swatchType: Types.GroupDimensionSwatchType;
    swatchUrl?: string | null;
    swatchColor?: { __typename?: 'Color'; hex: string; rgba: Array<number>; isLight: boolean } | null;
    groupDimension: { __typename?: 'ProductCatalogItemGroupDimension'; id: string; title: string };
  }>;
  group?: {
    __typename?: 'ProductCatalogItemGroup';
    id: string;
    groupDimensions: Array<{
      __typename?: 'ProductCatalogItemGroupDimension';
      id: string;
      title: string;
      options: Array<{
        __typename?: 'ProductCatalogItemGroupDimensionOption';
        id: string;
        displayString: string;
        swatchType: Types.GroupDimensionSwatchType;
        swatchUrl?: string | null;
        swatchColor?: { __typename?: 'Color'; hex: string; rgba: Array<number>; isLight: boolean } | null;
        groupDimension: { __typename?: 'ProductCatalogItemGroupDimension'; id: string; title: string };
      }>;
    }>;
    items: Array<{
      __typename?: 'ProductCatalogItem';
      whyWeLoveIt?: string | null;
      shortDescription?: string | null;
      longDescription?: string | null;
      id: string;
      title: string;
      itemType: string;
      productUrl?: string | null;
      isFullPrice: boolean;
      tags: Array<string>;
      rating?: { __typename?: 'RatingProduct'; id: string; stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number } } | null;
      groupDimensionOptions: Array<{
        __typename?: 'ProductCatalogItemGroupDimensionOption';
        id: string;
        displayString: string;
        swatchType: Types.GroupDimensionSwatchType;
        swatchUrl?: string | null;
        swatchColor?: { __typename?: 'Color'; hex: string; rgba: Array<number>; isLight: boolean } | null;
        groupDimension: { __typename?: 'ProductCatalogItemGroupDimension'; id: string; title: string };
      }>;
      retailer?: { __typename?: 'ProductCatalogRetailer'; name: string } | null;
      subCategories: Array<{ __typename?: 'ProductCatalogCategory'; id: string; publicUrlPath: string; title: string }>;
      collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo'; id: string; displayInfoId: string; pdpSectionType?: Types.PDPSectionType | null }>;
      brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
      photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      price?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      fullPrice?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo'; storefrontStatus: Types.ProductCatalogStorefrontStatus; canAddToCart: boolean; canAddToRegistry: boolean };
    }>;
  } | null;
};

export type CatalogPdpCollectionDisplayInfosFragment = {
  __typename?: 'ProductCatalogItem';
  collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo'; id: string; displayInfoId: string; pdpSectionType?: Types.PDPSectionType | null }>;
};

export type ProductCatalogPhotoAssetFragment = {
  __typename: 'ProductCatalogPhotoAsset';
  type: Types.ProductCatalogAssetType;
  photo: { __typename?: 'Photo'; id: string; url: string };
};

export type ProductCatalogVideoAssetFragment = {
  __typename: 'ProductCatalogVideoAsset';
  type: Types.ProductCatalogAssetType;
  video: {
    __typename?: 'ProductCatalogVideo';
    url: string;
    thumbnail: { __typename?: 'Photo'; id: string; url: string };
    fallbackImage: { __typename?: 'Photo'; id: string; url: string };
  };
};

export type GetCatalogProductDetailsQueryVariables = Types.Exact<{
  catalogItemId: Types.Scalars['ID'];
  withPdpSections: Types.Scalars['Boolean'];
  withProductRating: Types.Scalars['Boolean'];
  withInventory: Types.Scalars['Boolean'];
}>;

export type GetCatalogProductDetailsQuery = {
  __typename?: 'Query';
  productCatalogItemById?: {
    __typename?: 'ProductCatalogItem';
    whyWeLoveIt?: string | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    id: string;
    title: string;
    itemType: string;
    productUrl?: string | null;
    isFullPrice: boolean;
    tags: Array<string>;
    mediaAssets: Array<
      | { __typename: 'ProductCatalogPhotoAsset'; type: Types.ProductCatalogAssetType; photo: { __typename?: 'Photo'; id: string; url: string } }
      | {
          __typename: 'ProductCatalogVideoAsset';
          type: Types.ProductCatalogAssetType;
          video: {
            __typename?: 'ProductCatalogVideo';
            url: string;
            thumbnail: { __typename?: 'Photo'; id: string; url: string };
            fallbackImage: { __typename?: 'Photo'; id: string; url: string };
          };
        }
      | null
    >;
    storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo'; storefrontStatus: Types.ProductCatalogStorefrontStatus; canAddToCart: boolean; canAddToRegistry: boolean };
    rating?: { __typename?: 'RatingProduct'; id: string; stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number } } | null;
    parentCategories: Array<{
      __typename?: 'ProductCatalogCategory';
      id: string;
      publicUrlPath: string;
      lineage: Array<{ __typename?: 'ProductCatalogCategory'; id: string; publicUrlPath: string }>;
    }>;
    pdpSections?: Array<{
      __typename?: 'PDPSection';
      sectionType: Types.PDPSectionType;
      collectionType?: string | null;
      sectionTree?: {
        __typename?: 'PDPSectionTree';
        rootElementKey: string;
        elements: Array<{
          __typename?: 'PDPElement';
          key: string;
          elementType: Types.PDPElementType;
          childrenKeys: Array<string>;
          html?: string | null;
          text?: string | null;
          photo?: { __typename?: 'Photo'; id: string; url: string } | null;
        }>;
      } | null;
    }>;
    inventory?: { __typename?: 'ProductInventoryResult'; maxQty: number };
    retailer?: { __typename?: 'ProductCatalogRetailer'; name: string } | null;
    subCategories: Array<{ __typename?: 'ProductCatalogCategory'; id: string; publicUrlPath: string; title: string }>;
    groupDimensionOptions: Array<{
      __typename?: 'ProductCatalogItemGroupDimensionOption';
      id: string;
      displayString: string;
      swatchType: Types.GroupDimensionSwatchType;
      swatchUrl?: string | null;
      swatchColor?: { __typename?: 'Color'; hex: string; rgba: Array<number>; isLight: boolean } | null;
      groupDimension: { __typename?: 'ProductCatalogItemGroupDimension'; id: string; title: string };
    }>;
    group?: {
      __typename?: 'ProductCatalogItemGroup';
      id: string;
      groupDimensions: Array<{
        __typename?: 'ProductCatalogItemGroupDimension';
        id: string;
        title: string;
        options: Array<{
          __typename?: 'ProductCatalogItemGroupDimensionOption';
          id: string;
          displayString: string;
          swatchType: Types.GroupDimensionSwatchType;
          swatchUrl?: string | null;
          swatchColor?: { __typename?: 'Color'; hex: string; rgba: Array<number>; isLight: boolean } | null;
          groupDimension: { __typename?: 'ProductCatalogItemGroupDimension'; id: string; title: string };
        }>;
      }>;
      items: Array<{
        __typename?: 'ProductCatalogItem';
        whyWeLoveIt?: string | null;
        shortDescription?: string | null;
        longDescription?: string | null;
        id: string;
        title: string;
        itemType: string;
        productUrl?: string | null;
        isFullPrice: boolean;
        tags: Array<string>;
        rating?: { __typename?: 'RatingProduct'; id: string; stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number } } | null;
        groupDimensionOptions: Array<{
          __typename?: 'ProductCatalogItemGroupDimensionOption';
          id: string;
          displayString: string;
          swatchType: Types.GroupDimensionSwatchType;
          swatchUrl?: string | null;
          swatchColor?: { __typename?: 'Color'; hex: string; rgba: Array<number>; isLight: boolean } | null;
          groupDimension: { __typename?: 'ProductCatalogItemGroupDimension'; id: string; title: string };
        }>;
        retailer?: { __typename?: 'ProductCatalogRetailer'; name: string } | null;
        subCategories: Array<{ __typename?: 'ProductCatalogCategory'; id: string; publicUrlPath: string; title: string }>;
        collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo'; id: string; displayInfoId: string; pdpSectionType?: Types.PDPSectionType | null }>;
        brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
        photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
        price?: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        } | null;
        fullPrice?: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        } | null;
        storefrontInfo: { __typename?: 'ProductCatalogStorefrontInfo'; storefrontStatus: Types.ProductCatalogStorefrontStatus; canAddToCart: boolean; canAddToRegistry: boolean };
      }>;
    } | null;
    collectionDisplayInfos: Array<{ __typename?: 'ProductCatalogCollectionDisplayInfo'; id: string; displayInfoId: string; pdpSectionType?: Types.PDPSectionType | null }>;
    brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
    photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
    price?: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    } | null;
    fullPrice?: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    } | null;
  } | null;
};

export const CatalogPdpDisplayFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retailer' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'whyWeLoveIt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'productUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storefrontInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'storefrontStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToCart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToRegistry' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CatalogPdpCollectionDisplayInfosFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpCollectionDisplayInfos' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collectionDisplayInfos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayInfoId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpSectionType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CatalogPdpDimensionsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpDimensions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupDimensionOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'swatchColor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rgba' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'swatchUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupDimension' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'group' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupDimensions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'swatchColor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rgba' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupDimension' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpDisplayFields' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpCollectionDisplayInfos' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withProductRating' } } }],
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stats' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupDimensionOptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'swatchColor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rgba' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupDimension' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retailer' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'whyWeLoveIt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpCollectionDisplayInfos' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collectionDisplayInfos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayInfoId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpSectionType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'productUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storefrontInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'storefrontStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToCart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToRegistry' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProductCatalogPhotoAssetFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductCatalogPhotoAsset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogPhotoAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProductCatalogVideoAssetFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductCatalogVideoAsset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogVideoAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fallbackImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetCatalogProductDetailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCatalogProductDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'catalogItemId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withPdpSections' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withProductRating' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withInventory' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogItemById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'catalogItemId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpDisplayFields' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpDimensions' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpCollectionDisplayInfos' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogPhotoAsset' } },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductCatalogPhotoAsset' } }] },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogVideoAsset' } },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductCatalogVideoAsset' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'storefrontInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'storefrontStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddToCart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddToRegistry' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rating' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withProductRating' } } }],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stats' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parentCategories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lineage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pdpSections' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withPdpSections' } } }],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collectionType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sectionTree' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'rootElementKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'elements' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'childrenKeys' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'photo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inventory' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withInventory' } } }],
                    },
                  ],
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'maxQty' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retailer' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'whyWeLoveIt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpDimensions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupDimensionOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'swatchColor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rgba' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'swatchUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupDimension' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'group' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupDimensions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'swatchColor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rgba' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupDimension' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpDisplayFields' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogPdpCollectionDisplayInfos' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withProductRating' } } }],
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stats' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupDimensionOptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'swatchColor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rgba' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'swatchUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupDimension' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogPdpCollectionDisplayInfos' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collectionDisplayInfos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayInfoId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpSectionType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductCatalogPhotoAsset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogPhotoAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductCatalogVideoAsset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogVideoAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fallbackImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'productUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storefrontInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'storefrontStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToCart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToRegistry' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCatalogProductDetailsQuery__
 *
 * To run a query within a React component, call `useGetCatalogProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogProductDetailsQuery({
 *   variables: {
 *      catalogItemId: // value for 'catalogItemId'
 *      withPdpSections: // value for 'withPdpSections'
 *      withProductRating: // value for 'withProductRating'
 *      withInventory: // value for 'withInventory'
 *   },
 * });
 */
export function useGetCatalogProductDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>(GetCatalogProductDetailsDocument, baseOptions);
}
export function useGetCatalogProductDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>(GetCatalogProductDetailsDocument, baseOptions);
}
export type GetCatalogProductDetailsQueryHookResult = ReturnType<typeof useGetCatalogProductDetailsQuery>;
export type GetCatalogProductDetailsLazyQueryHookResult = ReturnType<typeof useGetCatalogProductDetailsLazyQuery>;
export type GetCatalogProductDetailsQueryResult = Apollo.QueryResult<GetCatalogProductDetailsQuery, GetCatalogProductDetailsQueryVariables>;
